import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { hideModal, setFormData, incrementStep } from '../WarrantyTransferForm/redux/actions';
import Address from './address';
import CheckBox from './Checkbox/index';
import Comps from '@owenscorning/react-library';
import RadioButton from './RadioButton/index.jsx';
import styles from './warranty-registration.module.scss';

const Modal = Comps.Connect.Modal

const SUGGESTED = 'suggested';
const USER_ENTERED = 'user_entered';

const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const NoSuggestionVerifier = ({ propertyOrOwner, addresses }) => {
  const userEnteredKey = `${propertyOrOwner}Address`
  const storeFieldKey = `verified${capitalizeFirstLetter(propertyOrOwner)}`
  const enteredAddress = addresses[userEnteredKey];

  return (
    <div className={styles.modalSection}>
      <h3>{`${capitalizeFirstLetter(propertyOrOwner)} Address`}</h3>
      <div className={styles.modalSection}>
        <div className={styles.radioOption}>
          <Address address={enteredAddress} />
        </div>
        <div className={styles.radioOption}>
          <CheckBox
            fieldKey={storeFieldKey}
            text={"I confirm this address is correct."}
          />
        </div>
      </div>
    </div>
  );
}

const AddressSuggestionPicker = ({ propertyOrOwner, addresses, selections, setSelection }) => {
  const selectionKey = `${propertyOrOwner}Selection`
  const suggestionKey = `suggested${capitalizeFirstLetter(propertyOrOwner)}`
  const userEnteredKey = `${propertyOrOwner}Address`
  const suggestedAddress = addresses[suggestionKey];
  const enteredAddress = addresses[userEnteredKey];
  const radioChanged = (event) => setSelection(event.target.value)

  if (_.isEqual(suggestedAddress, enteredAddress)) {
    return (
      <div>
        <h3>{`${capitalizeFirstLetter(propertyOrOwner)} Address matches suggestion exactly`}</h3>
      </div>
    );
  }

  return (
    <div className={styles.modalSection}>
      <h3>{`${capitalizeFirstLetter(propertyOrOwner)} Address`}</h3>
      <div>
        <div className={styles.radioOption}>
          <h5>Entered Address</h5>
          <RadioButton
            value={USER_ENTERED}
            fieldKey={'selections'}
            htmlAttributes={{}}
          >
            <Address address={enteredAddress} />
          </RadioButton>
        </div>
        <div className={styles.radioOption}>
          <h5>Suggested Address</h5>
          <RadioButton
            value={SUGGESTED}
            checked={selections == SUGGESTED}
            fieldKey={'selections'}
            htmlAttributes={{}}
          >
            <Address address={suggestedAddress} />
          </RadioButton>
        </div>
      </div>
    </div>
  );
}

const VerificationBody = (props) => {
    const { suggestedProperty, propertyAddress, suggestedOwner, ownerAddress, ownerAddressSameAsProperty } = props;
    const { setFormData, hideModal, incrementStep } = props
    const addresses = { suggestedProperty, propertyAddress, suggestedOwner, ownerAddress }
    const continueEnabled = (suggestedProperty || props.verifiedProperty)
        && (ownerAddressSameAsProperty || (suggestedOwner || props.verifiedOwner))
    const [propertySelection, setPropertySelection] = useState(SUGGESTED)
    const [ownerSelection, setOwnerSelection] = useState(SUGGESTED)
    const selections = { propertySelection, ownerSelection }

    useEffect(() => {
      const propertySameSuggested = _.isEqual(suggestedProperty, propertyAddress);
      const ownerSameSuggested = _.isEqual(suggestedOwner, ownerAddress);
      if (propertySameSuggested && ownerSameSuggested) {
        setFormData({
          verifiedProperty: true,
          verifiedOwner: true,
        });
        hideModal();
        incrementStep();
      }
    }, []);

    const updateThenSaveContinue = () => {
      let update = {};
      if (suggestedProperty.street) {
        update.verifiedProperty = true;
        if (propertySelection == SUGGESTED) {
          update.propertyAddress = suggestedProperty;
        }
      } else if (!suggestedProperty.street) {
        update.propertyAddress = propertyAddress;
      }
      if (suggestedOwner) {
        if (suggestedOwner.street1) {
          update.verifiedOwner = true;
          if (ownerSelection == SUGGESTED) {
            update.ownerAddress = suggestedOwner;
          }
        } else if (!suggestedOwner.street) {
          update.ownerAddress = ownerAddress;
        }
      }

      if (ownerAddressSameAsProperty) {
        update.verifiedOwner = (!!suggestedProperty) || props.verifiedProperty;
      }

      setFormData(update);
      hideModal();
      incrementStep();
    }

    return (
        <div>
          <h2>Please Verify Address</h2>
          <p>We could not verify the addresses entered. Please confirm the address you would like to use, or edit your entry.</p>

          {suggestedProperty.street && !suggestedOwner ?
            <AddressSuggestionPicker
                propertyOrOwner="property"
                addresses={addresses}
                selections={selections}
                setSelection={setPropertySelection}
            />
            :
            <NoSuggestionVerifier propertyOrOwner="property" addresses={addresses} />
          }
          {(ownerAddressSameAsProperty === "false") && (
            suggestedOwner.street ?
            <AddressSuggestionPicker
                propertyOrOwner="owner"
                addresses={addresses}
                selections={selections}
                setSelection={setOwnerSelection}
            />
            :
            <NoSuggestionVerifier propertyOrOwner="owner" addresses={addresses} />
          )}
          <div className={styles.modalSection}>
            <a
              data-track="form-edit"
              data-track-form-name="Warranty Form"
              data-track-form-step="address verification modal"
              className={"cta cta-secondary"}
              onClick={hideModal}>
                Edit Address
            </a>
            <a
              data-track="form-advance"
              data-track-form-name="Warranty Form"
              data-track-form-step="address verification modal"
              className={`cta ${continueEnabled ? '' : 'disabled'}`} onClick={updateThenSaveContinue}>Save & Continue</a>
          </div>
        </div>
    );
};

const UnderWarrantyBody = ({ propertyAddress, hideModal }) => {

  return (
      <div>
          <h2>Address Already Under Warranty</h2>
          <div>
              <p>This property address is associated with an existing warranty. Please contact us at answers.roofing@owenscorning.com or 1-800-ROOFING for assistance.</p>
              <h4>{"Property Address"}</h4>
              <div className={styles.radioOption}>
                  <Address address={propertyAddress} />
              </div>
          </div>
          <div className={styles.modalSection}>
              <a
                data-track="form-edit"
                data-track-form-name="Warranty Form"
                data-track-form-step="address verification modal"
                className={"cta cta-secondary"} onClick={hideModal}>Edit Address</a>
              <a
              data-track="close-modal"
              data-track-form-name="Warranty Form"
              data-track-form-step="address verification modal"
              className={"cta"} href="." >Cancel Registration</a>
          </div>
      </div>
  );
};

const AddressVerificationModal = (props) => {

    return (
      <Modal
        onClose={props.hideModal}
        open={props.showModal}
        className={styles.addressVerificationModal}
      >
        {props.hasExistingWarranty || false ?
          <UnderWarrantyBody {...props} /> :
          <VerificationBody {...props} />
        }
      </Modal>
    );
};


const mapStateToProps = state => (
    {
        dataComplaints: state.dataComplaints,
        ownerAddress: state.formData.ownerAddress,
        ownerAddressSameAsProperty: state.formData.ownerAddressSameAsProperty,
        propertyAddress: state.formData.propertyAddress,
        showModal: state.showModal,
        suggestedOwner: state.metadata.suggestedOwner,
        suggestedProperty: state.metadata.suggestedProperty,
        verifiedOwner: state.formData.verifiedOwner,
        verifiedProperty: state.formData.verifiedProperty,
        hasExistingWarranty: state.formData.hasExistingWarranty,
    }
);
const mapDispatchToProps = dispatch => (
    {
      hideModal: () => dispatch(hideModal()),
      setFormData: (hash) => dispatch(setFormData(hash)),
      incrementStep: () => dispatch(incrementStep()),
    }
);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddressVerificationModal);
